module.exports = __webpack_public_path__ + "img/icon_map_ymsh_c.eb3dc76e.png";